import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// En production, aucune sortie dans la console du navigateur (ni logs de
// bibliothèques tierces, ni traces de débogage oubliées).
if (process.env.NODE_ENV === 'production') {
  ['log', 'info', 'debug', 'warn', 'error', 'table', 'trace', 'group', 'groupCollapsed', 'dir'].forEach((m) => {
    try { console[m] = () => {}; } catch (_) { /* console en lecture seule */ }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
